<template>
  <div class="side-menu-wrapper">
    <slot></slot>
    <Menu
        width="100"
        ref="menu"
        theme="dark"
        :accordion = true
        :active-name="$route.query.paasCurrentFunctionId"
        :open-names="openNames"
        @on-select="selectItem">
      <template v-for="(item,index) in menus">
        <MenuItem
           :key="`menu_${index}`"ivu-menu-item
           :name="item.id"
           :to="{path:item.url}">
            <div class="side-menu-text">
                <Icon :type="item.iconClass" size="24" />
                <span>{{ item.title}}</span>
            </div>
        </MenuItem >
      </template>
    </Menu>
  </div>
</template>

<script>
export default {
  name: 'SideMenu',
  data(){
    return {
    "currentId":''
    }
  },
  props: {
    collapsed: {
      type: Boolean,
      default: false
    },
    menus: {
      type: Array,
      default: () => []
    },
  },
  computed: {
    openNames(){
      return this.getOpenArrByName(this.currentId, this.menus)
    }
  },
  methods: {
    getOpenArrByName(id, routerList) {
      let arr = []
      routerList.some(item => {
        if (item.id === id) {
          arr.push(item.id)
          return true
        }
        if (item.children && item.children.length) {
          let childArr = this.getOpenArrByName(id,item.children)
          if (childArr.length){
            arr = arr.concat(item.id,childArr)
            return true
          }
        }
      })
      return arr
    },
    selectItem(name){
     this.$emit('changeKeyData',name)
    },
    setUrlFuncId(funcUrl,id){
      if(funcUrl.indexOf("?") !== -1) {
        funcUrl += '&';
      } else {
        funcUrl += '?';
      }
      funcUrl += this.$store.state.funcIdName+"="+id;
      return funcUrl;
    }
  },
  mounted(){
    this.currentId = this.$route.query.paasCurrentFunctionId;
  },
  watch: {
    openNames(){//手动更新展开的子目录
        this.$nextTick(()=>{
          this.$refs.menu.updateOpened()
          this.$refs.menu.updateActiveName()
        })
    }
  }
}
</script>


<style scoped>
  .side-menu-wrapper{
    width: 100%;
  }
  .ivu-menu a.ivu-menu-item{
    color: #ffffff;
  }
  .ivu-menu-submenu-title {
    color: #ffffff;
  }
  /*.side-menu-wrapper .ivu-menu-vertical .ivu-menu-item:hover, .side-menu-wrapper .ivu-menu-vertical .ivu-menu-submenu-title:hover {
    color: #FFF;
    border-radius: 10px;
    background: rgba(255,255,255,0.4);
  }*/
  .ivu-menu-vertical .ivu-menu-item, .ivu-menu-vertical .ivu-menu-submenu-title {
      padding: 0px 0px;
      height: 70px;
      border-top: 1px solid #555555;
      border-bottom: 1px solid #2e2e2e;
      position: relative;
    /*color: #FFF;
    padding: 8px;
    height: 84px;
    width: 80px;
    margin-top:10px;
    border-radius: 10px;
    margin-left: 10px;*/
  }
  .ivu-menu-dark.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu){
      /*width: 80px;
      backgrounds: #f0faff;*/
    background: rgba(255,255,255,0.4);
  }
  .ivu-menu-dark.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu),
  .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu-title-active:not(.ivu-menu-submenu):hover {
      background: -webkit-linear-gradient(top, rgba(120,120,120,0.5) 0%,rgba(120,120,120,0.7) 100%);
  }
  .ivu-menu {
    background: url(../../../assets/images/backgrounds/sidebar.jpg);
    color: #ffffff;
    font-size: 16px;
    border-bottom: 1px solid #555555;
    text-align: center;
  }
  .ivu-menu-dark.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu), .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu-title-active:not(.ivu-menu-submenu){
      color: #f4f4f4;
  }
    /*.ivu-menu-item{
        border: 1px solid #2e2e2e;
        box-shadow: 0px 0px 2px #c9bfbf;
    }*/
  .side-menu-text{
      display: block;
      padding: 14px 0 8px 0;
      color: #bababa;
      font-size: 11px;
      width: 100px;
      text-decoration: none;
  }
  .side-menu-text span{
      display: block;
      padding-top: 4px;
      text-shadow: 0 1px 0 #303030;
      font-size: 11px;
  }
  .ivu-menu-dark.ivu-menu-vertical .ivu-menu-item:hover, .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu-title:hover{
      background: transparent;
  }
    .side-menu-text:hover{
        color: #f4f4f4;
        background: -webkit-linear-gradient(top, rgba(86,86,86,0.2) 0%,rgba(86,86,86,0.1) 100%);
    }
  .side-menu-text:active{
      background: -moz-linear-gradient(top, rgba(86,86,86,0.1) 0%, rgba(54,54,54,0.1) 100%);
      background: -webkit-linear-gradient(top, rgba(120,120,120,0.2) 0%,rgba(120,120,120,0.3) 100%);
      background: -o-linear-gradient(top, rgba(128,128,128,0.4) 0%,rgba(115,115,115,0.3) 100%);
      background: -ms-linear-gradient(top, rgba(86,86,86,0.2) 0%,rgba(54,54,54,0.1) 100%);
      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#33565656', endColorstr='#1a363636',GradientType=0 );
  }

</style>
